/**
 * Utility functions for sleeving selector
 */

/**
 * Detect if user is on mobile device
 */
export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Kindle|Silk|KFTT|KFOT|KFJWA|KFJWI|KFSOWI|KFTHWA|KFTHWI|KFAPWA|KFPWI/i.test(navigator.userAgent)
}

/**
 * Load images from source hash
 * @param {Object} sources - Hash of image sources
 * @returns {Promise<Object>} Promise that resolves with loaded images
 */
export function loadImages(sources) {
  return new Promise((resolve) => {
    const loadedImages = {}
    let loadedCount = 0
    const totalImages = Object.keys(sources).length

    if (totalImages === 0) {
      resolve(loadedImages)
      return
    }

    Object.entries(sources).forEach(([key, src]) => {
      const img = new Image()
      img.onload = () => {
        loadedImages[key] = img
        loadedCount++
        if (loadedCount >= totalImages) {
          resolve(loadedImages)
        }
      }
      img.onerror = () => {
        console.warn(`Failed to load image: ${key}`)
        loadedCount++
        if (loadedCount >= totalImages) {
          resolve(loadedImages)
        }
      }
      img.src = src
    })
  })
}

/**
 * Debounce function to limit how often a function can be called
 * @param {Function} func - The function to debounce
 * @param {number} wait - Milliseconds to wait
 * @returns {Function} Debounced function
 */
export function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}
